var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgUrl)?_c('img',{ref:"img",attrs:{"src":_vm._f("filterOssLink")(_vm.imgUrl),"alt":""},on:{"click":function($event){return _vm.previewImage($event)}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aa0c03c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/element/DubuImage.vue
// module id = null
// module chunks = 